export enum NOTIFICATION_PRIORITY {
  SITUATIONAL = 'situational',
  IMPORTANT = 'important',
  COMMON = 'common',
}

export interface InAppNotification {
  id: number;
  title: string;
  shortDescription: string;
  longDescription: string;
  imageUrl: string;
  icon: string;
  callToActionUrl: string;
  callToActionText: string;
  priority: NOTIFICATION_PRIORITY;
  createdAt: Date;
  expiration: Date;
}

export interface Recipient {
  id: number;
  email: string;
  inAppNotification: InAppNotification;
  viewedAt?: Date;
  createdAt: Date;
}
